import React from 'react';
import PropTypes from 'prop-types';

const SvgUndo = ({ active, ...props }) => {
    const fillColor = active ? '#128383' : '#EAEBF0';
    const strokeColor = active ? '#ffffff' : '#343A72';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="22" fill="none" viewBox="0 0 26 22" {...props}>
            <path
                fill={fillColor}
                fillRule="evenodd"
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="m1 7.993 3.452 3.347 3.758 3.64v-3.897c9.386 0 16.99 4.608 16.99 10.296 0-9.102-7.604-16.477-16.99-16.477V1L3.528 5.54 1 7.993Z"
                clipRule="evenodd"
            />
        </svg>
    );
};
SvgUndo.propTypes = {
    active: PropTypes.bool,
};
SvgUndo.defaultProps = {
    active: false,
};
export default SvgUndo;
